import React, { useEffect, useState } from 'react';
import { Popover, Button, Modal, message, Input } from 'antd';
import { restApi } from '../../../apis';
import { rest } from 'underscore';

function TitleComponent(props) {
  return (
    <div
      style={{
        display: 'flex',
        height: '4.2rem',
        justifyContetn: 'center',
        alignItems: 'center',
        background: '#7367F0',
        borderRadius: '10px 10px 0px 0px',
        paddingLeft: 20,
        color: '#FFF',
      }}
    >{`카테고리 메뉴`}</div>
  );
}
//----------------------------------------------------------------------------------------------------
function ContentComponent(props) {
  const {
    gModal,
    setGModal,
    uuid,
    name,
    setChildState,
    updateItem,
    deleteItem,
  } = props;
  const [modal, setModal] = useState({
    open: false,
    type: 1,
    message: '',
    btnTitle: '',
    categoryName: name,
  });

  // console.log('----->', props);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'center',
      }}
    >
      {/*----------------------------------------------------------------------------------------------------  */}
      <div
        style={{
          display: 'flex',
          marginTop: '-0.7rem',
          padding: '0rem 0rem 0rem 0rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
          onClick={(e) => {
            // Route.Link('/');
            setModal((prev) => {
              return {
                ...prev,
                open: true,
                type: 2,
                message: `대,중,소분류 중 중복되는 분류명이 있어 수정이 불가합니다.중복되는 분류명이 없도록 다시 입력해주세요.`,
                btnTitle: '수정',
              };
            });
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
          >
            {`카테고리명 수정`}
          </div>
        </Button>
      </div>
      {/*----------------------------------------------------------------------------------------------------  */}
      <div
        style={{
          display: 'flex',
          padding: '0rem 0rem 0rem 0rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <Button
          style={{
            display: 'flex',
            width: '100%',
            height: '5.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
          onClick={(e) => {
            setModal((prev) => {
              return {
                ...prev,
                open: true,
                type: 1,
                message: `삭제한 카테고리 및 카테고리에 포함된 하위 카테고리, 운동 데이터는 다시 복구할 수 없습니다.  정말  삭제하시겠습니까?`,
                btnTitle: '삭제',
              };
            });
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Public Sans',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
              color: '#DB4437',
            }}
          >
            {`카테고리 삭제`}
          </div>
        </Button>
      </div>
      {/*----------------------------------------------------------------------------------------------------  */}
      <Modal
        title={
          <div
          // style={{
          //   background: 'rgba(168, 170, 174, 0.16)',
          // }}
          >
            알림
          </div>
        }
        open={modal.open}
        centered
        closable={false} // Whether a close (x) button is visible on top right of the modal dialog or not
        footer={[
          <Button
            key="delete"
            type="primary"
            // loading={loading}
            onClick={async (e) => {
              if (modal.type == 1) {
                //삭제
                // await restApi.delete(`/admin/category/${uuid}`);
                deleteItem({ id: uuid });
              } else {
                //수정
                // await restApi.patch(`/admin/category/${uuid}`, { name: modal.categoryName, });
                updateItem({ id: uuid, name: modal.categoryName });
              }

              setChildState((prev) => {
                return {
                  ...prev,
                  loading: true,
                  reload: new Date(),
                };
              });

              setModal((prev) => {
                return { ...prev, open: false };
              });
            }}
            danger
          >
            {modal.btnTitle}
          </Button>,
          <Button
            key="cancel"
            type="default"
            onClick={(e) => {
              setModal((prev) => {
                return { ...prev, open: false };
              });
            }}
          >
            {`취소`}
          </Button>,
        ]}
      >
        {modal.type == 2 ? (
          <div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ width: '26%' }}>카테고리명:</div>
              <Input
                // style={{}}
                onChange={(e) => {
                  setModal((prev) => {
                    return {
                      ...prev,
                      categoryName: e.target.value,
                    };
                  });
                }}
                placeholder={modal.categoryName || '카테고리명을 입력해주세요.'}
              />
            </div>
            <p>{modal.message}</p>
          </div>
        ) : (
          <p>{modal.message}</p>
        )}
      </Modal>
      {/*----------------------------------------------------------------------------------------------------  */}
    </div>
  );
}
//----------------------------------------------------------------------------------------------------

const ExerciseCategoryPopover = (props) => {
  const { component, width } = props;

  return (
    <Popover
      placement="leftTop"
      title={TitleComponent({ ...props })}
      content={ContentComponent({ ...props })}
      trigger="focus"
      overlayStyle={{ width: 240 }}
      overlayInnerStyle={{ padding: 0 }}
      showArrow={false}
    >
      <Button
        type="link"
        style={{
          display: 'flex',
          width,
          flexDirection: 'column',
          justifyContetn: 'center',
          alignItems: 'center',
        }}
      >
        {component}
      </Button>
    </Popover>
  );
};

export default ExerciseCategoryPopover;
